import { Component, OnInit } from '@angular/core';

import { DropdownItem } from '@infocert/ng-ui-kit/models';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';

enum ContactSupportEnum {
  FAQ,
  DOCS,
  FEEDBACK,
}

@Component({
    selector: 'app-contact-support',
    templateUrl: './contact-support.component.html',
    styleUrls: ['./contact-support.component.scss'],
    standalone: false
})
export class ContactSupportComponent implements OnInit {
  dropdownItems$: Observable<DropdownItem[]>;
  isDropdownOpen: boolean = false;

  constructor(private translateService: TranslateService) {}

  getItems(n: number, icon = false) {
    return Array.from(Array(n).keys()).map((_, i) => ({
      label: `Placeholder ${i + 1}`,
      selected: i === 4,
      disabled: i === 2,
      iconBefore: icon ? 'chat_bubble_outline' : '',
    }));
  }
  ngOnInit(): void {
    this.dropdownItems$ = this.translateService
      .stream([
        'HEADER.CONTACT_SUPPORT.FAQ',
        'HEADER.CONTACT_SUPPORT.DOCS',
        'HEADER.CONTACT_SUPPORT.FEEDBACK',
      ])
      .pipe(
        map(res => [
          {
            label: res['HEADER.CONTACT_SUPPORT.FAQ'],
            value: ContactSupportEnum.FAQ,
          } as DropdownItem,
          {
            label: res['HEADER.CONTACT_SUPPORT.DOCS'],
            value: ContactSupportEnum.DOCS,
          } as DropdownItem,
          {
            label: res['HEADER.CONTACT_SUPPORT.FEEDBACK'],
            value: ContactSupportEnum.FEEDBACK,
            iconBefore: 'chat_bubble_outline',
          } as DropdownItem,
        ])
      );
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // onChangeDropdown(value: ContactSupportEnum) {
  //   const url =
  //     value === ContactSupportEnum.FAQ
  //       ? this.configService.config.url.faq
  //       : value === ContactSupportEnum.DOCS
  //       ? this.configService.config.url.docs
  //       : this.configService.config.url.feedback;
  //   window.open(url, '_blank');
  // }

  openSupport() {
    window.open(
      this.translateService.instant('URLS.CONTACT_SUPPORT_URL'),
      '_blank'
    );
  }
}
